import axios from "axios";
let APL_LINK = "http://192.168.1.9:8000/";
APL_LINK = "https://backendpython.uprestro.com/";
let local_server_link_react = APL_LINK + "api/v1/dineqr/";
// API functions
const get_pos_qr_menu = local_server_link_react + "get_pos_qr_menu";
const process_order = local_server_link_react + "phonepe_payment_initial";

// Retrieving data
const getCookie = (name) => {
  let value = null;
  if (document.cookie) {
    document.cookie.split(";").forEach((c) => {
      const cookie = c.trim();
      if (cookie.startsWith(name + "=")) {
        value = decodeURIComponent(cookie.substring(name.length + 1));
      }
    });
  }
  return value;
};
const server_post_data = async (url_for, form_data, packageName) => {
  // packageName = "uprestro_crm";
  if (form_data === null) {
    form_data = new FormData();
  }
  return axios.post(url_for, form_data, {
    withCredentials: true, // 🔐 REQUIRED
    headers: {
      "X-CSRFToken": getCookie("csrftoken"), // 🔐 REQUIRED
      "X-Package-Name": packageName,
    },
  });
};

export { get_pos_qr_menu, APL_LINK, server_post_data, process_order };
